import { deleteTemporada, getTemporadasPanel } from "../../services/TemporadasServices";
import { TemporadasContext } from "./TemporadasContext"


export const TemporadasState = ({ children }) => {
    const getTemporadasPanelData = async (search, numpag, filas) => {
        let res = await getTemporadasPanel(search, numpag, filas)
        return res;
    }

    const deleteTemporadaData = async (body,search, numpag, filas) => {
        const res = await deleteTemporada(body)
        if (res) getTemporadasPanelData(search, numpag, filas)
        return res
    }

    return <TemporadasContext.Provider value={{
        deleteTemporadaData,
        getTemporadasPanelData,
    }} >
        {children}
    </TemporadasContext.Provider>
}